var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33266",
    "data-name": "Group 33266",
    transform: "translate(-156.994 -256.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_901",
    "data-name": "Ellipse 901",
    transform: "translate(156.994 256.145)",
    fill: "none",
    stroke: "#ea8048",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21631",
    "data-name": "Rectangle 21631",
    width: 2,
    height: 9,
    transform: "translate(168.994 262.145)",
    fill: "#ea8048"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21632",
    "data-name": "Rectangle 21632",
    width: 2,
    height: 3,
    transform: "translate(168.994 273.145)",
    fill: "#ea8048"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.2c9e90c4cef71137b2a71a9617eecde4.svg";
export { ForwardRef as ReactComponent };